import { DropdownWithSearch } from "InnoUI/innoinput";
import React, { useEffect } from "react";
import { countryList } from "utils/optionData/utils";

//const ct = require("countries-and-timezones");

const HolidaysCountry = (props) => {
  const { onChange, defaultValue } = props;

  return (
    <DropdownWithSearch
      defaultValue={defaultValue || null} // Ensure it's null if not provided
      placeholder="Select Country"
      options={countryList}
      onChange={(value) => {
        onChange(value);
      }}
      borderColor="#ED850C"
      allowClear={true}
      disabled={true} // Make sure it's enabled
    />
  );
};

export default HolidaysCountry;
